import React from 'react'
import { observer,inject } from 'mobx-react'

import { withLayoutAdmin } from '../../utils/hoc'
import T from 'i18n-react'
import Grid from 'material-ui/Grid'
import Card, { CardContent } from 'material-ui/Card'
import TextField from 'material-ui/TextField'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'
import PropTypes from 'prop-types'


@inject('admin','ui','messenger') @observer
class ImpressumConfig extends React.Component {
  componentWillMount () {
    this.props.admin.getImpressum()
  }

  render () {
    const { classes,admin,ui } = this.props, xs = 12, sm = 6, md = 4, lg = 4, store = admin.impressum

    return (
      <Grid container direction="column" justify="center" align="center" spacing={Number(0)}>

      <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
       <Card className="admin-settings-card">
        <CardContent>

        <Typography type="headline" component="h2"> {T.translate("impressum.title")} </Typography>
        <Typography type="caption" component="p"> {T.translate("impressum.description")} </Typography>

        </CardContent>
       </Card>
      </Grid>

      <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
       <Card className="admin-settings-card">
        <CardContent>

         <TextField
          label={T.translate('impressum.phone')}
          value={store.phone}
          onChange={this.setPhone}
          onBlur={this.savePhone}
          fullWidth
         />

         <TextField
          label={T.translate('impressum.mail')}
          value={store.mail}
          onChange={this.setMail}
          onBlur={this.saveMail}
          fullWidth
         />

         <TextField
          label={T.translate('impressum.company')}
          value={store.company}
          onChange={this.setCompany}
          onBlur={this.saveCompany}
          fullWidth
         />

         <TextField
          label={T.translate('impressum.street')}
          value={store.street}
          onChange={this.setStreet}
          onBlur={this.saveStreet}
          fullWidth
         />

         <TextField
          label={T.translate('impressum.zip')}
          value={store.zip}
          onChange={this.setZip}
          onBlur={this.saveZip}
          fullWidth
         />

         <TextField
          label={T.translate('impressum.location')}
          value={store.location}
          onChange={this.setLocation}
          onBlur={this.saveLocation}
          fullWidth
         />

         <TextField
          label={T.translate('impressum.country')}
          value={store.country}
          onChange={this.setCountry}
          onBlur={this.saveCountry}
          fullWidth
         />

         <TextField
          placeholder={T.translate('impressum.multiplePersons')}
          label={T.translate('impressum.persons')}
          multiline
          value={store.persons}
          onChange={this.setPersons}
          onBlur={this.savePersons}
          fullWidth
         />

        </CardContent>
       </Card>
      </Grid>
     </Grid>
    )
  }

  setPhone = (e) => {
    this.props.admin.impressum.setPhone(e.target.value)
  }
  savePhone = () => {
   this.props.admin.impressum.savePhone( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setMail = (e) => {
    this.props.admin.impressum.setMail(e.target.value)
  }
  saveMail = () => {
   this.props.admin.impressum.saveMail( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setCompany = (e) => {
    this.props.admin.impressum.setCompany(e.target.value)
  }
  saveCompany = () => {
   this.props.admin.impressum.saveCompany( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setStreet = (e) => {
    this.props.admin.impressum.setStreet(e.target.value)
  }
  saveStreet = () => {
   this.props.admin.impressum.saveStreet( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setLocation = (e) => {
    this.props.admin.impressum.setLocation(e.target.value)
  }
  saveLocation = () => {
   this.props.admin.impressum.saveLocation( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setZip = (e) => {
    this.props.admin.impressum.setZip(e.target.value)
  }
  saveZip = () => {
   this.props.admin.impressum.saveZip( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setCountry = (e) => {
    this.props.admin.impressum.setCountry(e.target.value)
  }
  saveCountry = () => {
   this.props.admin.impressum.saveCountry( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setPersons = (e) => {
    this.props.admin.impressum.setPersons(e.target.value)
  }
  savePersons = () => {
   this.props.admin.impressum.savePersons( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
}



const styles = theme => ({
  logo: {
    width:'100%'
  }
})


ImpressumConfig.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(withLayoutAdmin(ImpressumConfig))



// WEBPACK FOOTER //
// ./src/components/admin/impressumconfig.js